export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8247.2fee7bd0.jpg";